import name from './name'

const selectSliceData = state => state[name]

const selectIsBusy = state => Boolean(selectSliceData(state).isBusy)

export { selectIsBusy }
